import {LOCAL_STORAGE_ORDER_DATA} from 'constants/analytics';
import {localStore} from 'libs/storage/storage';

/**
 * Get and parse order data from local storage.
 *
 * @returns {object} An object containing quoteItems and totals.
 */
export const getParsedOrderData = () => {
    const orderData = localStore.get(LOCAL_STORAGE_ORDER_DATA);
    if (!orderData) {
        return {quoteItems: [], totals: {}};
    }

    try {
        const parsedData = JSON.parse(orderData);
        return {
            quoteItems: parsedData.quoteItems || [],
            totals: parsedData.totals || {},
        };
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Error parsing order data:', error);
        return {quoteItems: [], totals: {}};
    }
};
